import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';
import './User.css';
import { Form, Button } from 'react-bootstrap';
// import APP_CONFIG from '../../config/appConfig';
import Multiselect from 'multiselect-react-dropdown';
import { useConfig } from '../../context/AppConfigContext';
import ScreenLoader from '../HtmlElements/ScreenLoader';
import Alert from '../HtmlElements/Alert';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { isValidEmail } from '../../services/commonService';

const AddUser = () => {
  useAuth(); // Ensure the user is authenticated

  const [loader, setLoader] = useState(false);
  const {appConfig} = useConfig();
  const passwordLength = 12;
  const useSymbols = true;
  const useNumbers = true;
  const useLowerCase = true;
  const useUpperCase = true;
  const [showPassword, setShowPassword] = useState(false);
  const [account_list, setAccounts] = useState([])
  const [selectedAssignedAccounts, setSelectedAssignedAccounts] = useState([]);

    const toggleShowPassword = () => {
      setShowPassword((prevShowPassword) => !prevShowPassword);
    };
    
    const generatePassword = () => {
      let charset = "";
      let newPassword = "";

      if (useSymbols) charset += "!@#$%^&*()";
      if (useNumbers) charset += "0123456789";
      if (useLowerCase) charset += "abcdefghijklmnopqrstuvwxyz";
      if (useUpperCase) charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

      for (let i = 0; i < passwordLength; i++) {
          newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
      }      
      const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/;
      if(newPassword.match(regex)) {
        setFormData((prevState) => ({
          ...prevState,
          'password': newPassword,
          'confirmPassword': newPassword,
        }));
      } else {
        //console.log('repeat in gene');      
        generatePassword();
    }
      //setFormData( {password: '55555555'});
          
  };

  const navigate = useNavigate();
  const { userId } = useParams(); // Get companyId from URL parameters

  const [formData, setFormData] = useState({
    companyId: '',
    userStatus: 1,
    firstName: '',
    lastName: '',
    email: '',
    userRole: '',
    userRoles: [],
    password: '',
    confirmPassword: '',
    designation: '',
    phone: '',
    country: '',
    time_zone: '',
    onboarding_status: 'demo',
    userDemoDate: "",
    userTrialStartDate: "",
    userTrialEndDate: "",
    contractStartDate: "",
    contractEndDate: "",
    isComplied:0
  });

  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  const [companies, setCompanies] = useState([]);


  const handleDateChange = (name, date) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: date || new Date(),
    }));

    // Clear date-related errors
    if (['userDemoDate'].includes(name)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        userDemoDate: '',
      }));
    }

    if (['contractStartDate', 'contractEndDate'].includes(name)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        contractEndDate: '',
      }));
    }

    if (['userTrialStartDate', 'userTrialEndDate'].includes(name)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        userTrialEndDate: '',
      }));
    }

    if (['contractStartDate', 'contractEndDate'].includes(name)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        contractEndDate: '',
      }));
    }

    // Clear API error
    setApiError('');
  };

  useEffect(() => {
    // Fetch company list from the API
    const fetchCompanies = async () => {
      setLoader(true);
      try {
        const filterData = {'is_active': 1, is_deleted: 0, limit: 1000}
        const response = await api.get('/companies/get_companies', { "params": filterData })
        const companies = [...response.data.result.list] ;

        companies.sort((a, b) => {
          const nameA = (a.company_name || "").toString().toLowerCase();
          const nameB = (b.company_name || "").toString().toLowerCase();
          return nameA.localeCompare(nameB);
        });

        setCompanies(companies); // Assuming the response contains an array of companies

      } catch (error) {
        console.error('Error fetching companies:', error);
      }
      setLoader(false);
    };

    fetchCompanies();
  }, []);

  useEffect(() => {
    if (userId) {
      setLoader(true);
      // Fetch existing company data if editing
      const filterData = {'id': userId }
      api.get('/users/get_users_list', { "params": filterData })
        .then(response => {
          const user = response?.data?.result?.list[0] ;

          setFormData({
            companyId: user.company_id,
            userStatus: user.is_active,
            firstName: user.firstname,
            lastName: user.lastname,
            email: user.email,
            password: '',
            confirmPassword: '',
            userRole: '26',
            userRoles: user.roles,
            designation: user.designation,
            phone: user.phone,
            country: user.country,
            companyDomain: user.companyDomain,
            functionrole: user.functionrole,
            accessType: user.accessType,
            newsletterAccess: user.newsletterAccess,
            assigned_accounts: user?.assigned_accounts || [],
            time_zone: user?.time_zone || '',
            onboarding_status: user?.onboarding_status || '',
            userDemoDate:user?.user_demo_date,
            userTrialStartDate:user?.user_trial_start_date,
            userTrialEndDate:user?.user_trial_end_date,
            contractStartDate:user?.contract_start_date, 
            contractEndDate:user?.contract_end_date,
            isComplied:user?.is_complied
          });
        })
        .catch(error => {
          setApiError('Error fetching user data');
          console.error('Error fetching user data:', error);
        });
      setLoader(false);
    }
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear the error for the current field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
    // console.log(formData);
  };

  const handleChangeMultiSelect = (rolesArr) => {
    const newRole = rolesArr.map((rolesObj) => {
      return rolesObj.id
    });
    setFormData({ ...formData, userRoles: newRole});
  }

  const handleRemoveMultiSelect = (selectedList) => {
    const selectedIds = selectedList.map(item => item.id);
    setFormData({
      ...formData,
      userRoles: selectedIds
    });
  };



  const handleChangeAccountsSelect = (assigned_accounts) => {
    const selectedVals = assigned_accounts.map((account) => {
      return account?.account_code
    });
    setFormData({ ...formData, assigned_accounts: selectedVals});
  }

  const handleRemoveAccountsSelect = (selectedList) => {
    const selectedIds = selectedList.map(item => item.account_code);
    setFormData({
      ...formData,
      assigned_accounts: selectedIds
    });
  };


  const validateForm = () => {
    let newErrors = {};
    if (!formData?.onboarding_status){
      newErrors.onboarding_status = 'User onboarding status is required';
    }else if(formData?.onboarding_status == 'demo' && formData?.userRoles?.some(num=> num==26 || num ==27) && !formData.userDemoDate ){
      newErrors.userDemoDate = 'User Demo date is required';
    }

    if (formData?.onboarding_status == 'trial' && formData?.userRoles?.some(num=> num==26 || num ==27) && moment(formData.userTrialEndDate).format('YYYY-MM-DD') <= moment(formData.userTrialStartDate).format('YYYY-MM-DD')) newErrors.userTrialEndDate = 'Trial End Date must be greater than Trial Start Date';
    if (formData?.onboarding_status == 'live' && formData?.userRoles?.some(num=> num==26 || num ==27) && moment(formData.contractEndDate).format('YYYY-MM-DD') <= moment(formData.contractStartDate).format('YYYY-MM-DD')) newErrors.contractEndDate = 'Contract End Date must be greater than Contract Start Date';
    if (!formData.companyId) newErrors.companyId = 'Company Name is required';
    if (!formData.firstName){
      newErrors.firstName = 'First Name is required';
    }else if(/[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.firstName)){
      newErrors.firstName = 'Special characters are not allowed in First Name';
    }

    if (!formData.lastName){
      newErrors.lastName = 'Last Name is required';
    }else if(/[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.lastName)){
      newErrors.lastName = 'Special characters are not allowed in Last Name';
    }

    if (!formData.time_zone) newErrors.time_zone = 'Select timezone of user';

    if (!formData.email) newErrors.email = 'Email Address is required';
    if(!isValidEmail(formData.email)){
      newErrors.email = 'Enter valid Email Address';
    }

    if (!(formData.userRoles.length)) newErrors.userRoles = 'User Role is required';


    if (!userId) {
      const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/;
      if(formData.password.match(regex)) {
      } else { newErrors.password = 'Password must be at least one uppercase, one lowercase, one special character and one number!';  }
      if (!formData.password) newErrors.password = 'Password is required';
      if (!formData.confirmPassword) newErrors.confirmPassword = 'Confirm Password is required';
      if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
    }

    if(formData.designation && /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.designation)){
      newErrors.designation = 'Special characters are not allowed in Designation';
    }
    
    if(formData.phone && (!/\(\d{3}\)\s*\d{3}-\d{4}/.test(formData.phone)
      || /[a-zA-Z][.]/.test(formData.phone)
      || /[~`!@#$%\^&*+=\\[\]\\';,/{}|\\":<>\?]/g.test(formData.phone) ) ){
      newErrors.phone = 'Please provide valid phone number e.g. (044) 456-7890 ';
    }

    console.log("newErrors : ", newErrors)

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return;
    }

    let company_name_text = companies.filter(function(r){
        return r.id === formData.companyId;
    });
    company_name_text = company_name_text?.[0]?.company_name;

    const formattedData = {
      company_id: formData.companyId,
      company_name: company_name_text,
      is_active: parseInt(formData.userStatus),
      firstname: formData.firstName,
      lastname: formData.lastName,
      password: formData.password,
      email: formData.email,
      role: formData.userRoles,
      roles: formData.userRoles,
      designation: formData.designation,
      accessType: formData.accessType,
      newsletterAccess: formData.newsletterAccess,
      functionrole: formData.functionrole,
      companyDomain: formData.companyDomain,      
      phone: formData.phone,
      country: formData.country,
      is_deleted: 0,
      is_verified: 1,
      assigned_accounts: formData?.assigned_accounts || [],
      time_zone: formData?.time_zone || '',
      
      onboarding_status: formData?.onboarding_status || '',
      // user_demo_date:formData?.userRoles?.some(num=> num==26 || num ==27) &&  moment(formData.userDemoDate).format('YYYY-MM-DD'),

      // user_trial_start_date:formData?.userRoles?.some(num=> num==26 || num ==27) &&  moment(formData.userTrialStartDate).format('YYYY-MM-DD'),
      // user_trial_end_date:formData?.userRoles?.some(num=> num==26 || num ==27) &&  moment(formData.userTrialEndDate).format('YYYY-MM-DD'),
      // contract_start_date:formData?.userRoles?.some(num=> num==26 || num ==27)  &&  moment(formData.contractStartDate).format('YYYY-MM-DD'),
      // contract_end_date:formData?.userRoles?.some(num=> num==26 || num ==27) &&  moment(formData.contractEndDate).format('YYYY-MM-DD'),

      user_demo_date: formData?.userRoles?.some(num => num == 26 || num == 27) && formData.userDemoDate
        ? moment(formData.userDemoDate).format('YYYY-MM-DD')
        : '',

      user_trial_start_date: formData?.userRoles?.some(num => num == 26 || num == 27) && formData.userTrialStartDate
        ? moment(formData.userTrialStartDate).format('YYYY-MM-DD')
        : '',

      user_trial_end_date: formData?.userRoles?.some(num => num == 26 || num == 27) && formData.userTrialEndDate
        ? moment(formData.userTrialEndDate).format('YYYY-MM-DD')
        : '',

      contract_start_date: formData?.userRoles?.some(num => num == 26 || num == 27) && formData.contractStartDate
        ? moment(formData.contractStartDate).format('YYYY-MM-DD')
        : '',

      contract_end_date: formData?.userRoles?.some(num => num == 26 || num == 27) && formData.contractEndDate
        ? moment(formData.contractEndDate).format('YYYY-MM-DD')
        : '',
        
      is_complied:formData?.userRoles?.some(num=> num==26 || num ==27) && formData?.isComplied
    };

    setLoader(true);

    // Add your form submission logic here (e.g., sending the data to an API)
    try {
      if(userId){
        formattedData.id = userId;
        delete(formattedData.password)
      }
      // const response = {}
      const response = await api.post('/users/add_user', formattedData);
      if (response.data.status === 201 || response.data.status === 200) {
        // navigate('/companies', { state: { success_message: response.data.result.message } });
        sessionStorage.setItem('successMessage', response.data.result.message);
        navigate('/users');
        
      } else {
        setApiError(response.data.result.message || 'An error occurred while saving the user.');
      }

    } catch (error) {
      const errorMsg = error.response?.data?.message || 'An error occurred while saving the user.';
      setApiError(errorMsg);
      console.error('Error saving user:', error);
    }
    setLoader(false);
  };

  useEffect(() => {
    // Fetch company list from the API
    const fetchAccounts = async () => {
      
      setLoader(true);
      try {

        const clientCode = formData?.companyId || '';
        if(clientCode != ""){
          let filter = {
            'client_code' : clientCode,
            'is_active': 1,
            'is_deleted': 0,
          };

          const response = await api.get('/accounts/get_accounts', {
            params: {          
              page: 1,
              limit: 2000, // perPage
              ...filter,
            },
          });

          let account_list = response?.data?.result.list || [];

          account_list = account_list.map(account => {
            return {
                account_code: account.account_code,
                account_name: account.account_name
            };
          });

          setAccounts(account_list); // Assuming the response contains an array of users

          // Get/Set Default selected accounts for user
          const getselectedAccountsObjects = (assigned_accounts) => {
            return account_list.filter(account => assigned_accounts.includes(account.account_code));
          };
          const selectedAssignedAccounts = getselectedAccountsObjects(formData?.assigned_accounts || []);
          setSelectedAssignedAccounts(selectedAssignedAccounts);
          // End: Get/Set Default selected accounts for user
        }

      } catch (error) {
        console.error('Error fetching accounts:', error);
      }
      setLoader(false);
    };

    fetchAccounts();
  }, [formData.companyId]);

  if(!appConfig){
    return <div> </div>;
  }

  const user_roles = appConfig.user_roles;
  const user_status_options = appConfig.user_status_options;
  const countryOptions = appConfig.country_options;
  const functionroles = appConfig.function_roles;
  const accessTypes = appConfig.accessTypes;
  const newsletterAccess = appConfig.newsletterAccess;
  const companyDomains = appConfig.company_domains;
  const timeZoneOptions = appConfig?.time_zones || [];
  const userComplianceAccess =  appConfig?.userComplianceAccess || { 1: 'Yes', 0: 'No' }


  const roles = Object.keys(user_roles).map(key => ({
    'name': user_roles[key],
    'id': parseInt(key)
  }));

  const getSelectedRoleObjects = (roleIds) => {
    return roles.filter(role => roleIds.includes(role.id));
  };

  const selectedRoleObjects = getSelectedRoleObjects(formData.userRoles);

  return (
    <div className="add_user_wrapper">
      {loader === true && (<ScreenLoader />)}
      <div className="mt-3">
        <div className='head_back'>
          <h4 className="add_user_headings mb-0">{userId ? 'Edit User' : 'Add User'}</h4>
        </div>
        {apiError && <Alert type="danger" message={apiError} />}
        <div className='row p-3'>
          <div className='col-md-12'>
            <Form onSubmit={handleSubmit} autoComplete='off'>
              <div className='mb-3 row'>
                <div className='col-md-6'>
                  <Form.Group >
                    <Form.Label className="form-label custom_label">Company Name <span className='red'>*</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="companyId"
                      className="form-control custom_form_control"
                      value={formData.companyId}
                      onChange={handleChange}
                      key="sel-company"
                      extra-param="sel-company">
                      <option value="">Select Company</option>
                      {companies.map(company => (
                        <option key={`sel-company-${company.id}`} value={company.id}>
                          {company.company_name}
                        </option>
                      ))}
                    </Form.Control>
                    {errors.companyId && <div className="text-danger custom_error_msg">{errors.companyId}</div>}
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <label htmlFor="labelAccountStatus" className="form-label custom_label">User Status</label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="userStatus"
                    value={formData.userStatus}
                    onChange={handleChange}>
                    {Object.keys(user_status_options).map((key) => (
                      <option key={`sel-status-${key}`} value={key}>{user_status_options[key]}</option>
                    ))}
                  </Form.Control>
                </div>
              </div>
              <div className="mb-3 row">
                <div className='col-md-6'>
                  <Form.Group >
                    <Form.Label className="form-label custom_label">First Name <span className='red'>*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      className="form-control custom_form_control"
                      value={formData.firstName}
                      onChange={handleChange}></Form.Control>
                    {errors.firstName && <div className="text-danger custom_error_msg">{errors.firstName}</div>}
                  </Form.Group>
                </div>
                <div className='col-md-6'>
                  <Form.Group>
                    <Form.Label className="form-label custom_label">Last Name <span className='red'>*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      className="form-control custom_form_control"
                      value={formData.lastName}
                      onChange={handleChange}></Form.Control>
                    {errors.lastName && <div className="text-danger custom_error_msg">{errors.lastName}</div>}
                  </Form.Group>
                </div>
              </div>

              <div className='mb-3 row'>
                <div className='col-md-6'>
                  <Form.Group>
                      <Form.Label className="form-label custom_label">User Role <span className='red'>*</span></Form.Label>
                      <Multiselect
                        name="userRoles"
                        // value={formData.userRoles}
                        options={roles}
                        onSelect={handleChangeMultiSelect}
                        onRemove={handleRemoveMultiSelect}
                        displayValue="name"
                        selectedValues={selectedRoleObjects}
                        showCheckbox="true"
                        placeholder="Select Roles"></Multiselect>
                      {errors.userRoles && <div className="text-danger custom_error_msg">{errors.userRoles}</div>}
                    </Form.Group>
                  
                </div>

                <div className='col-md-6'>
                  
                  <Form.Group>
                    <Form.Label className="form-label custom_label">Email Address <span className='red'>*</span></Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      className="form-control custom_form_control"
                      value={formData.email}
                      onChange={handleChange}></Form.Control>
                    {errors.email && <div className="text-danger custom_error_msg">{errors.email}</div>}
                  </Form.Group>
                  

                </div>
              </div>

              { typeof userId === "undefined" && 
              <div className="mb-3 row">
                <div className='col-md-6'>
                  <Form.Group>
                    <Form.Label className="form-label custom_label custom_generate_label">
                      Password <span className='red'>*</span>
                      <Link className="generate_password" onClick={generatePassword}>
                        <span className="">Generate Password</span>
                      </Link>
                    </Form.Label>
                    <div className="input-group">
                      <Form.Control
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        id="typepass"
                        autoComplete='new-password'
                        className="form-control custom_form_control"
                        value={formData.password}
                        onChange={handleChange}
                      />
                      <div className="input-group-append" style={{'position': 'absolute', 'right': '8px', 'top': '3px', 'zIndex': '5'}}>
                        <span className="" onClick={toggleShowPassword} style={{ cursor: 'pointer' }}>
                          <i className={`fa fa-eye${ showPassword ? '' : '-slash' }`} aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                    {userId && 
                      <span className='keep_blank_span'>
                        Keep blank if you don't want to change password
                      </span>
                    }
                    {/* <a href="javascript:void(0)" className='show_password'>
                      <span className='show_password_span'>
                        <input className='pl-2' type="checkbox" onClick={toggleShowPassword} />Show Password 
                      </span>
                    </a> */}
                    {errors.password && <div className="text-danger custom_error_msg">{errors.password}</div>}
                  </Form.Group>
                </div>
                <div className='col-md-6'>
                  <Form.Group>
                    <Form.Label className="form-label custom_label">Confirm Password <span className='red'>*</span></Form.Label>
                    <Form.Control
                      type="password"
                      name="confirmPassword"
                      autoComplete='new-password'
                      className="form-control custom_form_control"
                      value={formData.confirmPassword}
                      onChange={handleChange}/>
                    {errors.confirmPassword && <div className="text-danger custom_error_msg">{errors.confirmPassword}</div>}
                  </Form.Group>
                </div>
              </div>
              }

<div className="mb-3 row">
<div className="col-md-6">
                  <label htmlFor="labelIpAuthentication" className="form-label custom_label">Role / Function</label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="functionrole"
                    value={formData.functionrole}
                    onChange={handleChange}>
                      <option value="">Select Role / Function</option>
                     {Object.keys(functionroles).map((key) => (
                      <option key={key} value={key}>{functionroles[key]}</option>
                    ))}
                  </Form.Control>
                  {errors.functionrole && <div className="text-danger custom_error_msg">{errors.functionrole}</div>}
                </div>
                <div className='col-md-6'>
                <label htmlFor="labelCompanyDomain" className="form-label custom_label">Industry </label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="companyDomain"
                    value={formData.companyDomain}
                    onChange={handleChange}>
                    <option key="" value="">Select Industry</option>
                    {Object.keys(companyDomains).map((key) => (
                      <option key={key} value={key}>{companyDomains[key]}</option>
                    ))}
                  </Form.Control>
                  {errors.companyDomain && <div className="text-danger custom_error_msg">{errors.companyDomain}</div>}
                
                </div>
              </div>

              <div className="mb-3 row">
                <div className='col-md-6'>
                  <Form.Group>
                    <Form.Label className="form-label custom_label">Designation</Form.Label>
                    <Form.Control
                      type="text"
                      name="designation"
                      className="form-control custom_form_control"
                      value={formData.designation}
                      onChange={handleChange}/>
                    {errors.designation && <div className="text-danger custom_error_msg">{errors.designation}</div>}
                  </Form.Group>
                </div>
                <div className='col-md-6'>
                  <Form.Group>
                    <Form.Label className="form-label custom_label">Phone</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone"
                      className="form-control custom_form_control"
                      value={formData.phone}
                      onChange={handleChange}/>
                    {errors.phone && <div className="text-danger custom_error_msg">{errors.phone}</div>}
                  </Form.Group>
                </div>
              </div>

              <div className='mb-3 row'>
                <div className="col-md-6">
                  <label htmlFor="labelCountry" className="form-label custom_label">Country</label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}>
                    <option key="" value="">Select Country</option>
                    {Object.keys(countryOptions).map((key) => (
                      <option key={`country-${key}`} value={key}>{countryOptions[key]}</option>
                    ))}
                  </Form.Control>
                  {errors.country && <div className="text-danger custom_error_msg">{errors.country}</div>}
                </div> 

                <div className="col-md-6">
                  <label htmlFor="labelTimezone" className="form-label custom_label">Timezone</label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="time_zone"
                    value={formData?.time_zone || ''}
                    onChange={handleChange}>
                    <option key="" value="">Select Timezone</option>
                    {Object.keys(timeZoneOptions).map((key) => (
                      <option key={`time_zone-${key}`} value={key}>{timeZoneOptions[key]}</option>
                    ))}
                  </Form.Control>
                  {errors.time_zone && <div className="text-danger custom_error_msg">{errors.time_zone}</div>}
                </div>
                </div>

              <div className='row'>
                <div className="col-md-6">
                  <label htmlFor="labelIpAuthentication" className="form-label custom_label">Access Type</label>
                  <Form.Control
                    className="custom_form_control"
                    as="select"
                    name="accessType"
                    value={formData.accessType}
                    onChange={handleChange}>
                      <option value="">Select Access Type</option>
                     {Object.keys(accessTypes).map((key) => (
                      <option key={key} value={key}>{accessTypes[key]}</option>
                    ))}
                  </Form.Control>
                  {errors.accessType && <div className="text-danger custom_error_msg">{errors.accessType}</div>}
                </div>

                <div className='col-md-6'>
                  <label htmlFor="labelAccountStatus" className="form-label custom_label">Select Accounts</label>
                  <Multiselect
                        name="assigned_accounts"
                        value={formData?.assigned_accounts || []}
                        options={account_list}
                        onSelect={handleChangeAccountsSelect}
                        onRemove={handleRemoveAccountsSelect}
                        displayValue="account_name"
                        selectedValues={selectedAssignedAccounts}
                        showCheckbox={true}
                        placeholder="Select Accounts"></Multiselect>
                      
                      {errors?.accounts && <div className="text-danger custom_error_msg">{errors.accounts}</div>}
                    
                </div>
              </div>
              {
                formData?.userRoles?.some(num=> num==26 || num ==27) ?
                <>
                <div className='row' style={{padding: '10px'}}>
                  <div className='col-md-6' style={{
                    "border": "1px solid #ccc",
                    "borderRadius": "8px",
                    "marginRight": "10px",
                    "padding": "10px"
                  }}  >
                    <label>User Onboarding Dates:</label>

                    <div className='row'>
                      <div className="col-md-6">
                        <label
                          htmlFor="onboarding_status"
                          className="form-label custom_label"
                        >
                          User Status: <span className="red">*</span>
                        </label>
                        <Form.Control
                          className="custom_form_control"
                          as="select"
                          name="onboarding_status"
                          id="onboarding_status"
                          value={formData.onboarding_status}
                          onChange={handleChange}>
                            <option value="">Select Onboarding Status</option>
                            <option key="onboarding_status_demo" value="demo">Demo</option>
                            <option key="onboarding_status_trial" value="trial">Trial</option>
                            <option key="onboarding_status_live" value="live">Live</option>
                        </Form.Control>
                        {errors.onboarding_status && (
                          <div className="text-danger custom_error_msg">
                            {errors.onboarding_status}
                          </div>
                        )}
                      </div>
                    </div>
                    
                    {formData.onboarding_status == 'demo' && <div className="mb-3 row">
                      {/* <div className="col-md-6">
                        <label
                          htmlFor="labelDemoStartDate"
                          className="form-label custom_label"
                        >
                          Demo Start Date
                        </label>
                        <DatePicker
                          selected={formData?.userDemoStartDate}
                          onChange={(date) => handleDateChange("userDemoStartDate", date)}
                          dateFormat="yyyy-MM-dd"
                          className="form-control custom_form_control"
                          id="labelDemoStartDate"
                          minDate={ moment(new Date()).format('YYYY-MM-DD')}
                        />
                      </div> */}
                      <div className="col-md-6">
                        <label
                          htmlFor="labelDemoEndDate"
                          className="form-label custom_label"
                        >
                          Demo Date <span className="red">*</span>
                        </label>
                        <DatePicker
                          selected={formData.userDemoDate}
                          onChange={(date) => handleDateChange("userDemoDate", date)}
                          dateFormat="yyyy-MM-dd"
                          className="form-control custom_form_control"
                          id="labelDemoEndDate"
                          // minDate={ moment(new Date()).format('YYYY-MM-DD')}
                        />
                        {errors.userDemoDate && (
                          <div className="text-danger custom_error_msg">
                            {errors.userDemoDate}
                          </div>
                        )}
                      </div>
                    </div>
                    }

                    {formData.onboarding_status == 'trial' && <div className="mb-3 row">
                      <div className="col-md-6">
                        <label
                          htmlFor="labelSubscriptionStartDate"
                          className="form-label custom_label"
                        >
                          Trial Start Date
                        </label>
                        <DatePicker
                          selected={formData?.userTrialStartDate}
                          onChange={(date) => handleDateChange("userTrialStartDate", date)}
                          dateFormat="yyyy-MM-dd"
                          className="form-control custom_form_control"
                          id="labelSubscriptionStartDate"
                          // minDate={ moment(new Date()).format('YYYY-MM-DD')}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="labelSubscriptionEndDate"
                          className="form-label custom_label"
                        >
                          Trial End Date <span className="red">*</span>
                        </label>
                        <DatePicker
                          selected={formData.userTrialEndDate}
                          onChange={(date) => handleDateChange("userTrialEndDate", date)}
                          dateFormat="yyyy-MM-dd"
                          className="form-control custom_form_control"
                          id="labelSubscriptionEndDate"
                          // minDate={ moment(new Date()).format('YYYY-MM-DD')}
                        />
                        {errors.userTrialEndDate && (
                          <div className="text-danger custom_error_msg">
                            {errors.userTrialEndDate}
                          </div>
                        )}
                      </div>
                    </div>
                    }

                    {formData.onboarding_status == 'live' && <div className="mb-3 row">
                      <div className="col-md-6">
                        <label htmlFor="labelContractStartDate" className="form-label custom_label">
                          Contract Start Date
                        </label>
                        <DatePicker
                          selected={formData.contractStartDate}
                          onChange={(date) => handleDateChange("contractStartDate", date)}
                          dateFormat="yyyy-MM-dd"
                          className="form-control custom_form_control"
                          id="labelContractStartDate"
                          // minDate={ moment(new Date()).format('YYYY-MM-DD')}
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="labelContractEndDate" className="form-label custom_label">
                          Contract End Date <span className="red">*</span>
                        </label>
                        <DatePicker
                          selected={formData.contractEndDate}
                          onChange={(date) => handleDateChange("contractEndDate", date)}
                          dateFormat="yyyy-MM-dd"
                          className="form-control custom_form_control"
                          id="labelContractEndDate"
                          // minDate={ moment(new Date()).format('YYYY-MM-DD')}
                        />
                        {errors.contractEndDate && (
                          <div className="text-danger custom_error_msg">
                            {errors.contractEndDate}
                          </div>
                        )}
                      </div>
                    </div>
                    }
                  </div>
                </div>

                <div className='row'>
                  <div className="col-md-6">
                    <label htmlFor="labelUserComplied" className="form-label custom_label">User Complied</label>
                    <Form.Control
                      className="custom_form_control"
                      as="select"
                      name="isComplied"
                      value={formData.isComplied}
                      onChange={handleChange}>
                      {Object.keys(userComplianceAccess).map((key) => (
                          <option key={key} value={key}>{userComplianceAccess[key]}</option>
                        ))}
                    </Form.Control>
                  </div>
                </div>
                </>:null
              }

               <div className='row'>
                  <div className='col-md-6'>
                    <label htmlFor="labelIpAuthentication" className="form-label custom_label">Newsletter Access</label>
                    <Form.Control
                      className="custom_form_control"
                      as="select"
                      name="newsletterAccess"
                      value={formData.newsletterAccess}
                      onChange={handleChange}>
                      {Object.keys(newsletterAccess).map((key) => (
                        <option key={key} value={key}>{newsletterAccess[key]}</option>
                      ))}
                    </Form.Control>
                    {errors.newsletterAccess && <div className="text-danger custom_error_msg">{errors.newsletterAccess}</div>}
                  </div>
               </div>

              
              <div className='row'>
                <div className='col-md-12 pt-3'>
                  <Button type="submit" className="btn btn-primary custom_login_btn pull-right">
                    Submit
                  </Button>
                  <Link to="/users/" className="btn btn-light pull-right cancel_btn">Cancel</Link>

                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
